import React from 'react';
import { StackedColumn } from '../../../../../../core';
import { CernerSlot, LocationGroup } from '../../../../../../api/models';
import ResultLocationGroup from './resultLocationGroup/ResultLocationGroup';

export interface ResultLocationGroupsProps {
  locationGroups: LocationGroup[];
  onSlotSelected: (
    slot: CernerSlot,
    locationId?: string,
    locationName?: string
  ) => void;
}

const ResultLocationGroups: React.FC<ResultLocationGroupsProps> = (
  props: ResultLocationGroupsProps
) => {
  return (
    <StackedColumn>
      {props.locationGroups.map((locationGroup) => (
        <ResultLocationGroup
          key={locationGroup.locationId}
          locationGroup={locationGroup}
          onSlotSelected={props.onSlotSelected}
        />
      ))}
    </StackedColumn>
  );
};

export default ResultLocationGroups;
